import logo from '../assets/VibeChecker.svg';
import upload from '../assets/upload.svg';
import './Home.css';
import axios from 'axios';

import React, { useEffect, useState } from 'react';

import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';

import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hsqjrdifsnxrkwyehhey.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhzcWpyZGlmc254cmt3eWVoaGV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk2NDgxMTQsImV4cCI6MjA0NTIyNDExNH0.PACJoo6iCmukz6LXGtDCfKwv2dUfzv1rI3FWw1DD3P0'
const supabase = createClient(supabaseUrl, supabaseKey)

const { v4: uuidv4 } = require('uuid');

const Home = () => {
    const navigate = useNavigate();

    const cld = new Cloudinary({ cloud: { cloudName: 'dqyt74s85' } });

    const uploadImage = async (image) => {
        if (image.size) {
            const formData = new FormData();
            formData.append('file', image); // Append the selected image
            formData.append('upload_preset', 'preset'); // Upload preset from Cloudinary

            try {
                await axios.post(
                    'https://api.cloudinary.com/v1_1/dqyt74s85/image/upload',
                    formData
                ).then((response) => {
                    insertData(response.data.public_id);
                })
            } catch (error) {
                console.error('Error uploading the image', error);
            }
        }
    };

    const insertData = async (image_id) => {
        console.log('image:' + image_id);
        const design_id = uuidv4();
        await supabase
            .from('stats')
            .insert([
                {
                    id: uuidv4(),
                    what: 'upload'
                }
            ])
        await supabase
            .from('designs')
            .insert([
                {
                    id: design_id,
                    image_id: image_id
                }
            ])
            .then(() => navigate(`review/${design_id}`));
    };

    const img = cld
        .image('cld-sample-3')
        .format('auto') // Optimize delivery by resizing and applying auto-format and auto-quality
        .quality('auto')
        .resize(auto().gravity(autoGravity()).width(500).height(500));
    return (
        // <AdvancedImage cldImg={img}/>
        <div className="Home">
            <header className="Home-header">
                <img src={logo} className="Home-logo" alt="logo" />
                <p>
                    Check your design’s vibe
                </p>
                <div className='container' onClick={uploadImage}>
                    <input
                        type="file"
                        accept='.jpg, .jpeg, .png'
                        id="file-upload"
                        style={{ display: 'none' }}
                        onChange={(event) => uploadImage(event.target.files[0])}
                    />
                    <label htmlFor="file-upload" className="custom-file-input">
                        Choose Image
                    </label>
                </div>
            </header>
        </div>
    );
}

export default Home;
